/**
 * Given by criteria, IDs and content blocker ID decide if the consent is given.
 */ function decideToUnblock(by, requiredIds, blockerId, checker, /**
     * The condition of the consent. Can be `and` or `or`.
     *
     * - `and` = All required IDs need to be accepted
     * - `or` = At least one required ID needs to be accepted
     */ condition = "and") {
    const required = typeof requiredIds === "string" ? requiredIds.split(",") : requiredIds;
    const consentTransport = {};
    for (const requiredId of required){
        consentTransport[requiredId] = {
            consent: false
        };
    }
    const { blocker } = checker(by, consentTransport, blockerId);
    const consentsToCheck = Object.values(consentTransport).filter(({ consent })=>consent !== null);
    if (consentsToCheck.length === 0) {
        return {
            consent: true,
            blocker
        };
    }
    const consent = condition === "and" ? consentsToCheck.every(({ consent })=>consent) : consentsToCheck.some(({ consent })=>consent);
    return {
        consent,
        blocker
    };
}
export { decideToUnblock };
